<script setup>
import { computed, onMounted, reactive, ref } from "vue";

const modal = reactive({
    isOpen: false,
});
const formRef = ref(null);

const props = defineProps({
    availableTags: Array,
    tags: Array,
    action: String,
    csrf: String,
    category: String,
});

const teamId = computed(() => {
    return new URLSearchParams(window.location.search).get("teamId");
});
const categoryId = computed(() => {
    return new URLSearchParams(window.location.search).get("category");
});
</script>

<template>
    <button
        class="
            text-sm
            rounded-lg
            px-2
            py-1
            flex
            items-center
            bg-accent
            text-white
        "
        @click="modal.isOpen = true"
    >
        <ion-icon name="create-outline" class="text-xl mr-2"></ion-icon>
        Edit access
    </button>
    <teleport to="body">
        <div
            v-show="modal.isOpen"
            class="
                bg-black bg-opacity-25
                fixed
                top-0
                left-0
                w-full
                h-full
                z-[1000]
                flex
                items-center
                justify-center
            "
        >
            <div
                class="
                    bg-white
                    rounded-lg
                    shadow-lg
                    p-4
                    relative
                    font-sans
                    min-w-[30vw]
                    max-w-[40vw]
                "
            >
                <header class="flex items-center mb-2">
                    <h3 class="mr-12 text-2xl font-semibold">
                        Edit "{{ props.category }}" access
                    </h3>
                    <button
                        type="button"
                        class="
                            rounded-md
                            ml-auto
                            leading-[0]
                            p-1
                            bg-gray-100
                            hover:bg-gray-200
                            text-xl
                        "
                        @click="modal.isOpen = false"
                    >
                        <ion-icon name="close"></ion-icon>
                    </button>
                </header>
                <div class="text-gray-500">
                    Edit access for team forum categories
                </div>

                <hr class="my-6" />
                <form
                    ref="formRef"
                    @submit="submit"
                    :action="action"
                    method="post"
                >
                    <input type="hidden" name="team_id" :value="teamId" />
                    <input
                        type="hidden"
                        name="category_id"
                        :value="categoryId"
                    />
                    <input type="hidden" name="_token" :value="csrf" />
                    <div class="flex gap-2">
                        <TagForm
                            :available-tags="props.availableTags"
                            :tags="props.tags"
                        ></TagForm>
                    </div>
                    <div class="mt-8 my-2 flex items-center justify-end gap-4">
                        <button
                            type="button"
                            class="
                                flex
                                py-2
                                px-6
                                border
                                font-bold
                                border-accent
                                rounded-full
                                text-accent
                                items-center
                            "
                            @click="modal.isOpen = false"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            class="
                                flex
                                py-2
                                px-4
                                bg-primary
                                font-bold
                                rounded-full
                                text-white
                                items-center
                            "
                        >
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </teleport>
</template>

<style scoped></style>
